import { Component } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';

import Breadcrumbs from '../BreadCrumbs';

import withComponentName from '../../../decorators/withComponentName';
import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';

import { getCountry } from '../../../helpers/companyHelpers';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class CountryFilings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryName: '',
      providerList: [],
    };
    autoBind(this);
  }

  componentDidMount() {
    const { match } = this.props;
    const { countryCode } = match.params || {};
    const foundCountry = getCountry(countryCode);

    if (!foundCountry?.sources?.length) {
      window.location.href = '/404';
      return;
    }

    this.setState({
      providerList: foundCountry?.sources || [],
      countryName: foundCountry?.name,
    });
  }

  onRowSelect({ ticker }) {
    const { match, history } = this.props;
    const { countryCode } = match.params || {};
    history.push(`/directory/filings/${countryCode}/${ticker}`);
  }

  render() {
    const { match, searchBarActive } = this.props;
    const { countryName, providerList } = this.state;

    return (
      <div className={cx(Styles.filings, searchBarActive && Styles.blurred)}>
        <Breadcrumbs match={match} />
        <div className={Styles.filings_header}>
          Filings from
          {' '}
          {countryName}
        </div>
        <div className={Styles.filings_header_details}>
          <p>
            Browse official company filings for an entire country by regulator or industry group,
            like a stock exchange. Listed companies will publish filings to both regulators and
            exchanges, while private companies may have regulatory filings only.
          </p>
        </div>
        <div className={Styles.fillings_country_list}>
          {
            providerList.map((country) => (
              <CountryListComponent
                key={country.id}
                isMore={country.isMore}
                ticker={country.ticker}
                name={country.name}
                image={country.image}
                onRowSelect={this.onRowSelect}
              />
            ))
          }
        </div>
      </div>
    );
  }
}

const CountryListComponent = ({
  name, image, isMore, ticker, onRowSelect,
}) => {
  const rowClass = cx(Styles.country_row, isMore && Styles.country_row_more);

  const handleRowClick = () => {
    if (isMore) return;
    onRowSelect({ ticker });
  };

  return (
    <div className={rowClass} onClick={handleRowClick}>
      {
        image
          ? <img alt="" src={image} width={35} height={35} loading="lazy" />
          : <div className={Styles.country_more} />
      }
      <div className={Styles.country_row_text}>{name}</div>
    </div>
  );
};

const mapStateToProps = ({
  searchReducers,
}) => ({
  searchBarActive: searchReducers.searchBarActive,
});

export default withComponentName(connect(mapStateToProps, null)(withMetatag(CountryFilings, 'directory/filings')));
